var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_47_2",
    "data-name": "Component 47 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4631",
    "data-name": "Rectangle 4631",
    width: 17,
    height: 17,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "push-pin",
    d: "M.032,5.034a.236.236,0,0,1,.144-.172,5.776,5.776,0,0,1,4.34.068L8.033,1.938A2.643,2.643,0,0,1,8.519.088.238.238,0,0,1,8.69,0a.245.245,0,0,1,.18.069l3.606,3.606a.237.237,0,0,1-.02.352,2.683,2.683,0,0,1-1.826.486L7.623,8.047A6.2,6.2,0,0,1,7.7,12.381a.236.236,0,0,1-.387.08L3.864,9.017.657,12.225a.236.236,0,1,1-.334-.334L3.53,8.683.1,5.249A.237.237,0,0,1,.032,5.034ZM4.2,8.688l3.173,3.173A6,6,0,0,0,7.134,8.1a.237.237,0,0,1,.035-.25l3.182-3.74a.237.237,0,0,1,.181-.083.21.21,0,0,1,.036,0,2.446,2.446,0,0,0,1.37-.226L8.746.613A2.217,2.217,0,0,0,8.518,2a.236.236,0,0,1-.08.218L4.707,5.389a.239.239,0,0,1-.261.03,5.4,5.4,0,0,0-3.751-.24Z",
    transform: "translate(2.214 2.235)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinChat);
export default __webpack_public_path__ + "static/media/pinChat.0f33818cb88555a78135cc5735e5400a.svg";
export { ForwardRef as ReactComponent };